<div
    class="tile-preview-wrapper"
    [class.tile-preview-compact]="variant === 'compact'"
    [class.tile-preview-link]="tile.kind === 'link'"
    [class.tile-preview-cover]="showCover"
    [style.--tile-accent]="tile.color || '#6366f1'"
>
    <p-card class="tile-card tile-card-simple">
        <div class="tile-identity">
            <img
                *ngIf="showCover"
                class="tile-cover-image"
                [src]="coverImageUrl"
                alt=""
                (error)="onImageError('cover')"
            >
            <div
                *ngIf="!showCover || tile.imageMode === 'cover-icon'"
                class="tile-simple-icon"
                [class.tile-icon-on-cover]="showCover"
                [class.tile-simple-icon-editable]="editable"
                [class.tile-simple-icon-filled]="showImage && fillsIcon"
                [ngStyle]="{'background-color': showImage ? '#fff' : (tile.color ?? '#6366f1'), 'box-shadow': iconBoxShadow}"
                [attr.role]="editable ? 'button' : null"
                [attr.tabindex]="editable ? 0 : null"
                [attr.aria-label]="editable ? selectIconLabel : null"
                (click)="onIconClick()"
                (keydown)="onIconKeydown($event)"
            >
                <img
                    *ngIf="showImage; else symbol"
                    [src]="iconImageUrl"
                    alt=""
                    class="tile-simple-icon-image"
                    (error)="onImageError()"
                >
                <ng-template #symbol><i
                        [ngClass]="iconClass"
                        [ngStyle]="{color: iconColor}"
                    ></i></ng-template>
                <div
                    class="tile-simple-icon-overlay"
                    *ngIf="editable"
                >
                    <i class="ri-image-edit-line"></i>
                </div>
            </div>
        </div>
        <div class="tile-simple-text">
            <b>{{tile.name || tile.text}}</b>
            <small *ngIf="tile.subtext">{{tile.subtext}}</small>
        </div>
        <i
            *ngIf="variant === 'compact'"
            class="tile-navigation"
            [ngClass]="tile.openInNewTab ? 'ri-external-link-line' : 'ri-arrow-right-line'"
            aria-hidden="true"
        ></i>
    </p-card>
    <span
        *ngIf="showVisibilityInfo"
        class="tile-visibility-badge"
        tabindex="0"
        role="img"
        [attr.aria-label]="visibilityTooltip"
        [pTooltip]="visibilityTooltip"
        [tooltipEvent]="variant === 'compact' ? 'both' : 'hover'"
        tooltipPosition="top"
        tooltipStyleClass="tile-visibility-tooltip"
        (click)="$event.preventDefault(); $event.stopPropagation()"
    >
        <i
            class="ri-question-line"
            aria-hidden="true"
        ></i>
    </span>
</div>
